import { createAction, props } from '@ngrx/store';
import { Token } from '@stripe/stripe-js';

import { OcSystemAccounting } from '@offconon/core-api';

export const createPaymentIntent = createAction(
  '[Stripe Card Pay] Create Payment Intent',
  props<{ addressBookId: number }>(),
);

export const createPaymentIntentSuccess = createAction(
  '[Stripe Card Pay] Create Payment Intent Success',
  props<{ clientSecret: string }>(),
);

export const createPaymentIntentFailure = createAction(
  '[Stripe Card Pay] Create Payment Intent Failure',
  props<{ error: any }>(),
);

export const walletPayment = createAction(
  '[StripeCardPay] Initiate Wallet Card Payment',
  props<{
    token: Token;
    addressBookId: number;
    amount: string | number;
    currency: string;
  }>(),
);
export const shoppingCartPayment = createAction(
  '[StripeCardPay] Initiate Shopping Cart Card Payment',
  props<{
    token: Token;
    addressBookId: number;
    amount: string | number;
    currency: string;
  }>(),
);
export const subscriptionPayment = createAction(
  '[StripeCardPay] Initiate Subscription Card Payment',
  props<{
    token: Token;
    addressBookId: number;
  }>(),
);

export const confirmCardPaymentSuccess = createAction(
  '[StripeCardPay] Confirm Card Payment Success',
  props<{ result: OcSystemAccounting }>(),
);
export const confirmSubscriptionCardPaymentSuccess = createAction(
  '[StripeCardPay] Confirm Subscription Card Payment Success',
  props<{ result: OcSystemAccounting }>(),
);

export const confirmCardPaymentFailure = createAction(
  '[StripeCardPay] Confirm Card Payment Failure',
  props<{ error: any }>(),
);

export const createCardToken = createAction(
  '[StripeCardPay] Create Card Token',
  props<{ card: any; stripe: any; addressBookId: number }>(),
);

export const createCardTokenFailure = createAction(
  '[StripeCardPay] Create Card Token Failure',
  props<{ error: string }>(),
);

export const resetStripeCardPayState = createAction('[StripeCardPay] Reset State');
